/**
 * Filtros da consulta paginada de sessões SWAP
 * (`PR_SWAP_SESSAO_CONSULTA`).
 *
 * O `guid` do usuário NÃO faz parte deste DTO — ele é enviado pelo
 * `SwapService` como query string (`?guid=...`).
 *
 * Quando `pageNumber` / `rowsPage` forem `null`, a procedure retorna
 * todos os registros (sem paginação).
 */
export interface SwapSessaoConsultaFiltro {
  /** ISO datetime — início do intervalo de data de criação (inclusivo). */
  dthCriacaoDe?: string | null;
  /** ISO datetime — fim do intervalo de data de criação (inclusivo, dia civil). */
  dthCriacaoAte?: string | null;
  codMotorista?: number | null;

  /** 'SIM' | 'NAO' — abastecimento realizado. */
  dscAbastecimentoRealizado?: 'SIM' | 'NAO' | null;
  /** 'SIM' | 'NAO' — filtra `FLG_AUTORIZADO` (=1 / =0); null na sessao so em Todos. */
  dscAutorizado?: 'SIM' | 'NAO' | null;

  /** Placa (7 caracteres). */
  dscPlaca?: string | null;
  /**
   * Filtro opcional de validade na proc (não é o "até" de criação no portal).
   * Mantido para compatibilidade com a API; a tela de autorização manual não envia.
   */
  dthValidade?: string | null;

  /** Coluna de ordenação. Default no backend: 'DTH_ULT_ATIVIDADE'. */
  ordenacao?: SwapSessaoOrdenacao;
  /** True = DESC, False = ASC. Default no backend: true. */
  ordenacaoDesc?: boolean;

  /** Página base 1. Null = sem paginação. */
  pageNumber?: number | null;
  /** Linhas por página. Null = sem paginação. */
  rowsPage?: number | null;
}

/** Colunas aceitas pela proc `PR_SWAP_SESSAO_CONSULTA` em `ORDENACAO`. */
export type SwapSessaoOrdenacao =
  | 'COD_SESSAO'
  | 'DTH_CRIACAO'
  | 'DTH_ULT_ATIVIDADE'
  | 'ETAPA'
  | 'COD_MOTORISTA'
  | 'DSC_NOME_MOTORISTA'
  | 'DSC_PLACA'
  | 'DSC_CARTAO'
  | 'DSC_COMBUSTIVEL'
  | 'COD_FROTA'
  | 'VLR_TOTAL'
  | 'COD_ABASTECIMENTO';
